<mat-dialog-actions class="mt-6 p-0">
    <div class="d-flex w-100 gap-3">
        <ng-content></ng-content>
        @for (action of actions();track $index) {
            @let status = (action.formStatus | async) || 'INVALID';

            <ui-button [label]="action.label | translate"
                       [type]="'primary'"
                       [loading]="status === 'PENDING'"
                       [disabled]="status === 'INVALID' || status === 'PENDING'"
                       [square]="true"
                       (handlerClick)="action.handlerClick()"
            />
        }

        <ui-button [label]="'global.actions.cancel' | translate"
                   [type]="'outline'"
                   [square]="true"
                   class="ms-auto"
                   mat-dialog-close />
    </div>
</mat-dialog-actions>
